import * as WebVitals from 'web-vitals';

window.WebVitals = WebVitals;
